import AdditionalWorkingTimeTicketDetail from './AdditionalWorkingTimeTicketDetail';

export default AdditionalWorkingTimeTicketDetail;
